export const local = {
  serviceURL: "http://localhost:8182",
};
export const dev = {
  serviceURL: "https://ricc-refresh-services-dev.ssnc-corp.cloud",
};
export const qa = {
  serviceURL: "https://ricc-refresh-services-qa.ssnc-corp.cloud",
};
export const uat = {
  serviceURL: "https://uat-apis.ssnc.cloud/ricc-refresh-uat",
};
export const prod = {
  serviceURL: "https://apis.ssnc.cloud/ricc-refresh",
};
